import { useMyWalletPerformanceFilterLogic } from 'azshared';
import React from 'react';
import { PerformanceCategoryFilter } from './performance-category-filter';
import { PerformanceDateFilter } from './performance-date-filter';
import './performance-filter.scss';
import { DossierToggle } from './dossier-toggle';

export const PerformanceFilter = () => {
	const { performanceFilter, onPerformanceFilterChange } = useMyWalletPerformanceFilterLogic();

	return (
		<div className='app-performance-filter'>
			<div>
				<PerformanceCategoryFilter filter={performanceFilter} onFilterChange={onPerformanceFilterChange} />
			</div>
			<div className='divider'>
				<PerformanceDateFilter />
				<DossierToggle />
			</div>
		</div>
	);
};
